import { composeFieldPath } from '@northfork/basics'
import { CounterParty } from '../../counter-party.model'
import { Security } from '../../security.model'
import { TransactionTypeKey } from '../../transaction-type.model'
import { AccountDetails } from '../account-details.model'
import { ExternalUnmatchedTransaction } from '../external-unmatched-transaction'
import { MvtData } from '../market-value-transfer.model'
import { GenericDataMap, Transaction } from '../transaction'
import { TransferPurchaseInfo } from './transfer-purchase-info.model'
import { InventoryType } from '../../inventory-type.model'

export interface SecurityTransfer extends Transaction {
  inventoryType: string
  postDate: string
  clearedDate?: string
  amount: number
  transferPrice: number
  clientLotId?: string | null
  units: number
  counterPartyId: number
  counterParty?: CounterParty
  securityId?: number
  dataMap?: GenericDataMap
  factor?: number
  oldClientLotId?: string | null
}

export interface SecurityGrid {
  accountDetails?: AccountDetails
  reconDate: Date
}

export interface TransferPositionData {
  sessionReconDate: string
  assetId: string
  cwanIdentifier?: string
  accountId: number
  units: number
  inventoryType?: InventoryType
  collateralBroker?: string
}

export interface BasisGridEdit extends SecurityGrid {
  tranType: TransactionTypeKey
  mvtMap?: Map<string, MvtData>
  tpiMap?: Map<string, TransferPurchaseInfo>
}

export interface BasisGridExternal extends SecurityGrid {
  transaction: ExternalUnmatchedTransaction
  security: Security
}

export interface GenericGridTransaction extends SecurityGrid {
  transaction:
    | SecurityTransfer
    | ExternalUnmatchedTransaction
    | TransferPositionData
  security: Security
}
export const securityField = composeFieldPath([] as SecurityMappingModel[])
export interface SecurityMappingModel {
  id: keyof SecurityMappingRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  type: 'string' | 'number' | 'date'
  isEditable: boolean
  field: string
  value: string
  errorMessage?: string
  isVisible: boolean
}

export interface SecurityMappingRow {
  account: string
  tranType: string
  inventoryType: string
  cusip: string
  cwanIdentifier?: string
  entryDate: string
  units: string
  transferPrice: string
  sourceAccountId: string
  exchangeType: string
  clientLotId?: string
  collateralBroker: string
}

export interface SecurityTransferSaveModalInput {
  warningMessage: string
}

export interface CalculatedFactorRequest {
  basisSettleDateMap: { [key: string]: string }
}

export interface CalculatedFactorResponse {
  basisId: number
  factor: number
}
